module.exports = __webpack_public_path__ + "static/media/sort-alpha-up-alt.d209f347.svg";